import { render, staticRenderFns } from "./downloadPage.vue?vue&type=template&id=e94f0870&scoped=true&"
import script from "./downloadPage.vue?vue&type=script&lang=js&"
export * from "./downloadPage.vue?vue&type=script&lang=js&"
import style0 from "./downloadPage.vue?vue&type=style&index=0&id=e94f0870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94f0870",
  null
  
)

export default component.exports